/** IANA time zone of this browser, e.g. `Europe/Berlin`. */
export function browserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

/** Every IANA time zone the browser knows, plus UTC, with the given one included even if it is not listed. */
export function timeZoneOptions(current?: string): string[] {
  // Not in the TypeScript lib this app targets yet; every current browser has it.
  const { supportedValuesOf } = Intl as { supportedValuesOf?: (key: 'timeZone') => string[] };
  const supported = [...new Set(['UTC', ...(supportedValuesOf ? supportedValuesOf('timeZone') : [browserTimeZone()])])];
  return current && !supported.includes(current) ? [current, ...supported] : supported;
}
